import { Navigate, Route, Routes } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock, faCog, faWrench } from '@fortawesome/free-solid-svg-icons';
import LayoutMain from '../../../../components/Layouts/LayoutMain1/LayoutMain1';
import Parametros from '../pages/Parametros/Index';
import { useLang } from '../../../../language';
import Aparato from '../pages/Aparatos/Aparato';
import Aparatos from '../pages/Aparatos/Index';
import Alquileres from '../pages/Alquileres/Index';
import Alquiler from '../pages/Alquileres/Alquiler/Index';

interface IModulesRouterAlquilerAparatos {
    pathRoot: string
}

export default function ModulesRouterAlquilerAparatos({ pathRoot }: IModulesRouterAlquilerAparatos) {

    const Lang = useLang()

    const navLinks = [
        {
            icon: <FontAwesomeIcon icon={faClock} />,
            title: Lang('ALQUILERES'),
            link: `${pathRoot}/alquileres`
        },
        {
            icon: <FontAwesomeIcon icon={faWrench} />,
            title: Lang('APARATOS'),
            link: `${pathRoot}/aparatos`
        },
        {
            icon: <FontAwesomeIcon icon={faCog} />,
            title: Lang('PARAMETROS'),
            link: `${pathRoot}/parametros`
        },
    ]

    return (
        <section className='LayoutMain animate__animated animate__fadeIn'>

            <LayoutMain label={Lang('GESTOR_DE_CONTENIDOS')}>

                <LayoutMain.NavLinks navLinks={navLinks} />

                <LayoutMain.Body>

                    <Routes>

                        <Route
                            path="alquileres"
                            element={<Alquileres />}
                        />

                        <Route
                            path="alquileres/:id/*"
                            element={<Alquiler/>}
                        />

                        <Route
                            path="aparatos"
                            element={<Aparatos />}
                        />

                        <Route
                            path="aparatos/:id/*"
                            element={<Aparato pathName='aparatos' />}
                        />

                        <Route
                            path="Parametros/*"
                            element={<Parametros />}
                        />

                        <Route
                            path="*"
                            element={<Navigate to={`${pathRoot}/alquileres`} replace />}
                        />
                    </Routes>

                </LayoutMain.Body>

            </LayoutMain>

        </section>
    )
}